<template>
  <div class="wrapper fill-vh">
    <div>
      <div class="heading">
        <h2>Olet jo hyödyntänyt ilmaisen kokeilun!</h2>
      </div>
      <p class="air">
        Tietojemme mukaan olet
        <small>({{ email }})</small> jo ladannut
        {{ getSelectedClub.genetive }} ilmaisen kokeilupassin.
      </p>
      <p class="air">
        Joko olisi aika ostaa asiakkuus? Paina alla olevaa painiketta ja katso,
        mikä asiakkuuksistamme sopisi sinulle parhaiten!
      </p>
      <Button v-bind:data="getSelectedClub.errorBtn" />
    </div>

    <div>
      <div class="buttons">
        <Button
          v-for="btn in getSelectedClub.buttons"
          :key="btn.text"
          v-bind:data="btn"
        />
      </div>
      <Suosittele v-bind:error="true" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Button from "@/components/Button";
import Suosittele from "@/components/Suosittele";

export default {
  name: "Error",
  data: () => ({
    email: "",
    error: true
  }),
  components: {
    Button,
    Suosittele
  },
  computed: mapGetters(["getSelectedClub"]),
  created() {
    this.email = this.$route.query.email;
  }
};
</script>

<style scoped>
p {
  margin-bottom: 1em;
}
.wrapper > div:first-of-type {
  margin-bottom: 3em;
}
.buttons {
  margin: 2em 0;
}
@media (min-width: 1025px) {
  .wrapper {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .wrapper > div {
    width: 48%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
}
</style>
